import React, { useState, useEffect } from "react";
import { IoMdAdd } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { createUser, fetchBlocks, fetchPanchayats } from "../../../services/api";
import AlertMsg from "../../../components/AlertMsg/AlertMsg";
import Loading from "../../../components/Loading/Loading";

const SupervisorDetails = () => {
  const initialState = {
    id: 0,
    name: "",
    emailId: "",
    mobileNo: "",
    password: "",
    otp: "",
    roleId: 2,
    blockId: 0,
    activeStatus: true,
  };
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [panchayat, setPanchayat] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const handleMoveDetails = () => {
    setTimeout(() => {
      history.push("/supervisor");
    }, 2000);
  };
  const handleCancel = () => {
    setFormData(initialState);

    history.push("/supervisor");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobileNo") {
      const numericValue = value.replace(/[^0-9]/g, "");

      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleBlockChange = (e) => {
    const selectedBlockId = e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      panchayatId: selectedBlockId, // Update blockId
    }));
  };

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    // Name validation
    if (!formData.name.trim()) {
      formErrors.name = "Supervisor name is required";
      isValid = false;
    }

    // Email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.emailId.trim()) {
      formErrors.emailId = "Email is required";
      isValid = false;
    } else if (!emailPattern.test(formData.emailId)) {
      formErrors.emailId = "Invalid email format";
      isValid = false;
    }

    // Mobile number validation
    const mobilePattern = /^\d{10}$/;
    if (!formData.mobileNo.trim()) {
      formErrors.mobileNo = "Phone number is required";
      isValid = false;
    } else if (!mobilePattern.test(formData.mobileNo)) {
      formErrors.mobileNo = "Phone number must be 10 digits";
      isValid = false;
    }

    // Password validation
    if (!formData.password.trim()) {
      formErrors.password = "Password is required";
      isValid = false;
    }

    // Block validation
    if (!formData.panchayatId) {
      formErrors.panchayatId = "Please select a block";
      isValid = false;
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      return; 
    }
    setLoading(true);
    try {
      const response = await createUser(formData);
      setAlert({
        visible: true,
        message: "Supervisor added successfully!",
        type: "success",
      });
      console.log("Supervisor saved successfully:", response.data);

      handleMoveDetails();
    } catch (error) {
      console.error("Error saving supervisor:", error);

      setAlert({
        visible: true,
        message: "Error adding supervisor. Please try again.",
        type: "error",
      });
    }finally {
      setLoading(false);
    }
  };

  const fetchPanchayat = async () => {
    try {
      const response = await fetchPanchayats();
      setPanchayat(response.data);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  };
  useEffect(() => {
    fetchPanchayat();
  }, []);
  const getSortedOptions = (options) => {
    return options
      .filter(option => option && option.name.trim() !== "") // Filter out empty values
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort in ascending order
      .map(option => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ));
  };

  return (
    <section>
      {loading && <Loading/>}
      {!loading && (
      <div className="details-container">
        {alert.visible && (
          <AlertMsg
            message={alert.message}
            type={alert.type}
            onClose={() => setAlert({ ...alert, visible: false })}
          />
        )}
        <div className="container-head p-15">
          <h2>Supervisor Details</h2>
        </div>

        <form>
          <div className="details-row">
            <div className={`inputs-details ${errors.name ? "error" : ""}`}>
              <label>Supervisor Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Supervisor Name"
                required
                className={errors.name ? "input-error" : ""}
              />
            </div>
          </div>

          <div className="details-row">
            <div className={`inputs-details ${errors.emailId ? "error" : ""}`}>
              <label>Email</label>
              <input
                type="email"
                name="emailId"
                value={formData.emailId}
                onChange={handleChange}
                placeholder="Email"
                required
                className={errors.emailId ? "input-error" : ""}
              />
            </div>
            <div className={`inputs-details ${errors.password ? "error" : ""}`}>
              <label>Password</label>
              <input
                type="text"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Password"
                required
                className={errors.password ? "input-error" : ""}
              />
            </div>
          </div>

          <div className="details-row">
            <div className={`inputs-details ${errors.mobileNo ? "error" : ""}`}>
              <label>Phone Number</label>
              <input
                type="text"
                name="mobileNo"
                value={formData.mobileNo}
                onChange={handleChange}
                placeholder="Phone Number"
                maxLength={10}
                title="Phone number must be 10 digits."
                required
                className={errors.mobileNo ? "input-error" : ""}
              />
            </div>
            <div className={`inputs-details ${errors.panchayatId ? "error" : ""}`}>
              <label>Panchayat</label>
              <select
                name="panchayatId"
                className={errors.panchayatId ? "input-error" : ""}
                id="panchayatId"
                onChange={handleBlockChange}
                value={formData.panchayatId}
                style={{ overflowY: 'auto' }} 
              >
                <option value="">Select Panchayat</option>
                {getSortedOptions(panchayat)}
              </select>

            </div>
          </div>
          <div className="j-end">
            <div className="details-button">
              <button
                type="button"
                className="close-btn"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="save-btn"
                onClick={handleSave}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Save"}
              </button>
            </div>
          </div>
        </form>
      </div>
      )}
    </section>
  );
};

export default SupervisorDetails;
